import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TranslatePipe} from "@ngx-translate/core";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit, OnDestroy {

    model: any[] = [];
    langChangeSubscription!: Subscription;

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
        this.langChangeSubscription = this.translate.onLangChange.subscribe(() => this.updateModel());
    }

    updateModel() {
        this.model = [
            {
                label: 'SIPO',
                icon: 'pi pi-fw pi-server',
                routerLink: ['/sipo']
            },
/*            {
                label: 'Task',
                icon: 'pi pi-fw pi-wrench pi-cog',
                routerLink: ['/task']
            },*/
            {separator: true},


        ];
    }

    ngOnDestroy() {
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
    }
}
